import { FGListen, FGSelectInput } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router-dom";

import { useReferential } from "../../../hooks/useReferential";
import { DrupalFormGenerator } from "../../common/DrupalFormGenerator";
import { EDrupalRoutes } from "../../EDrupalRoutes";
import { isBrcs } from "../../DrupalApp";

export interface IDrupalBreedSearchBarProps {
  onSelectionChanged?: (breedId) => void;
}

export const DrupalBreedSearchBar: React.FunctionComponent<IDrupalBreedSearchBarProps> = ({ onSelectionChanged }) => {
  const [breeds, bLoading] = useReferential((c) => c.getBabyDogBreedsQuery(null, isBrcs), false, []);
  const history = useHistory();
  return (
    <DrupalFormGenerator
      initialValues={{ breed: 0 }}
      onSubmit={() => {}}
      editMode={true}
      showDeleteButton={false}
      hideButtons={true}
      saving={false}
      deleting={false}
      enableDirtyCheck={false}
    >
      <FGListen
        field="breed"
        onChanged={(value) => {
          if (!value || value < 1) return;
          onSelectionChanged ? onSelectionChanged(value) : history.push(`${EDrupalRoutes.breed}/${value}`);
        }}
      />
      <FGSelectInput items={breeds} loading={bLoading} name="breed" leftIcon={"search"} />
    </DrupalFormGenerator>
  );
};
